import script from "./IdentityVerification.vue?vue&type=script&setup=true&lang=js"
export * from "./IdentityVerification.vue?vue&type=script&setup=true&lang=js"

import "./IdentityVerification.vue?vue&type=style&index=0&id=5fb76ecd&lang=less&scoped=true"

import exportComponent from "/data/web/pay/brpay/brpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fb76ecd"]])

export default __exports__